$('.mobile-toggle-menu').click(function(){
  $('body').toggleClass('is-active');
})
$('.js-dropdownToggle').click(function(e){
  e.preventDefault();
  $(this).next().attr("aria-hidden",false);
})
$('.js-dropdownCloser').click(function(){
  $(this).closest('.header__nav__dropdown').attr("aria-hidden",true)
});
jQuery(document).ready(function () {
  jQuery('img:not([alt])').attr('alt', '');
  jQuery('input[placeholder="Search"]').each(function(i) {
	jQuery(this).attr("aria-label", $(this).attr('placeholder'));
}); 
  jQuery('textarea[placeholder="Order Notes"]').each(function(i) {
    jQuery(this).attr("aria-label", $(this).attr('placeholder'));
});
jQuery(".mobile-search").click(function(){
  $(".mobile-search-box").toggle();
});  
});